import { validateField } from 'lib/functions';

/* Configuração padrão para as requisições do tipo multipart */
export const MULTIPART_CONFIG = {
    headers: { 'Content-Type': 'multipart/form-data' }
};

/* Retorna o modo atual do formulário */
export const getFormMode = (match, location) => {
    const params = match?.params || {};
    const id = params.id ?? params.codveiculo ?? '';
    const pathname = location?.pathname || '';

    return {
        id,
        isNewRecord: id === 'novo',
        isView: pathname.includes('/view')
    };
};

/* Retorna o primeiro registro de uma resposta padrão */
export const getRecordFromResponse = (response) => {
    return response?.data?.data?.[0] || null;
};

/* Retorna a lista de dados de diferentes formatos de resposta */
export const getResponseData = (response, defaultValue = []) => {
    if (Array.isArray(response?.data?.data)) {
        return response.data.data;
    }

    if (Array.isArray(response?.data)) {
        return response.data;
    }

    return defaultValue;
};

/* Retorna a melhor mensagem disponível no erro da API */
export const getApiErrorMessage = (error, fallbackMessage) => {
    return (
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.response?.data?.mensagem ||
        error?.message ||
        fallbackMessage
    );
};

/* Valida os campos informados conforme o schema */
export const validateSchemaFields = (data, schema, fields) => {
    const errors = {};

    fields.forEach(field => {
        const error = validateField(field, data[field], schema);

        if (error) {
            errors[field] = error;
        }
    });

    return errors;
};

/* Une as listas sem duplicar registros pelo campo informado */
export const mergeUniqueByField = (currentItems = [], newItems = [], field) => {
    const mergedItems = [...currentItems];

    newItems.forEach(item => {
        const alreadyExists = mergedItems.some(currentItem => (
            String(currentItem[field]) === String(item[field])
        ));

        if (!alreadyExists) {
            mergedItems.push(item);
        }
    });

    return mergedItems;
};